import { Typography } from '@telavita-core/react-design-kit'
import React from 'react'
import ModalGeneric from '../ModalGeneric'

import { Container, Icon, Image, InformationItem, InformationList } from './styles'

import { ReactComponent as RatingImage } from 'static/svg/rating-nps.svg'
import { ReactComponent as ChatIcon } from 'static/svg/chat-icon.svg'
import { ReactComponent as WifiIcon } from 'static/svg/wifi-icon.svg'
import { ReactComponent as ClockIcon } from 'static/svg/clock-icon.svg'
import { ReactComponent as MegaphoneIcon} from 'static/svg/megaphone-icon.svg'
import { ReactComponent as CouchIcon} from 'static/svg/couch-icon.svg'

interface NpsHowToImproveModalProps {
  onClose: () => void
}

export const NpsHowToImproveModal = ({
  onClose,
}: NpsHowToImproveModalProps): JSX.Element => {
  return (
    <ModalGeneric
      modalTitle='Dicas para melhorar sua nota na avaliação dos pacientes?'
      hasButton
      btnText='ENTENDI'
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <Container>
        <Image>
          <RatingImage width='100%'/>
        </Image>

        <InformationList>

          <InformationItem>
            <Icon>
              <ChatIcon />
            </Icon>
            <Typography
              variant='content2'
            >
              <>Apresente-se na primeira sessão. Esclareça como o tratamento acontecerá, explique um pouco sobre a sua abordagem e <strong>acolha a dor do seu paciente.</strong></>
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <WifiIcon />
            </Icon>
            <Typography
              variant='content2'
            >
              <>Verifique a <strong>qualidade da sua internet.</strong> Este é o seu principal instrumento de trabalho no ambiente online.</>
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <ClockIcon />
            </Icon>
            <Typography
              variant='content2'
            >
              <>Seja pontual e <strong>chegue SEMPRE no horário agendado.</strong></>
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <MegaphoneIcon />
            </Icon>
            <Typography
              variant='content2'
            >
              <><strong>Caso tenha algum imprevisto, avise com antecedência</strong> o paciente e o time de atendimento da Telavita.</>
            </Typography>
          </InformationItem>

          <InformationItem>
            <Icon>
              <CouchIcon />
            </Icon>
            <Typography
              variant='content2'
            >
              <>
                Esteja em um ambiente privado e adequado, respeitando assim, o <strong><i>setting</i> terapêutico</strong>. 
                Lembre-se que transmitir uma imagem profissional também é importante no ambiente online.
              </>
            </Typography>
          </InformationItem>

        </InformationList>
      </Container>
    </ModalGeneric>
  )
}